import React, { ReactElement, FC, useState, ReactNode, CSSProperties } from 'react'
import { Button, Card, Typography } from 'antd'
import { PlusSquareOutlined, MinusSquareOutlined } from '@ant-design/icons'
import AnimateHeight from 'react-animate-height'
import { s } from './style'

const { Text } = Typography

interface ExpandingCardProps {
  title: string | ReactNode
  canExpand?: boolean
  defaultExpanded?: boolean
  expandedExtraText?: string
  collapsedExtraText?: string
  bodyStyle?: CSSProperties
}

export const ExpandingCard: FC<ExpandingCardProps> = ({
  title,
  canExpand = true,
  defaultExpanded,
  expandedExtraText,
  collapsedExtraText,
  bodyStyle,
  children,
}): ReactElement => {
  const [height, setHeight] = useState(defaultExpanded ? 'auto' : '0')

  const handleExpandCollapse = (): void => {
    if (height === '0') {
      setHeight('auto')
    } else {
      setHeight('0')
    }
  }

  const expandCollapseButton = (
    <Button
      type='text'
      onClick={handleExpandCollapse}
      icon={height === '0' ? <PlusSquareOutlined /> : <MinusSquareOutlined />}
    />
  )

  let extra: boolean | ReactNode = false
  if (canExpand) {
    if (expandedExtraText && collapsedExtraText) {
      extra = (
        <div style={s.expand}>
          <Text>{height === '0' ? collapsedExtraText : expandedExtraText}</Text>
          {expandCollapseButton}
        </div>
      )
    } else {
      extra = expandCollapseButton
    }
  }

  return (
    <Card title={title} bodyStyle={s.card} extra={extra}>
      <AnimateHeight height={height}>
        <div style={{ ...s.content, ...bodyStyle }}>{children}</div>
      </AnimateHeight>
    </Card>
  )
}
